import React from "react";
import { Asset } from "src/types/assets";
import { Article } from "src/types/coaching/microLearning";
import { Podcast } from "src/types/coaching/podcast";
import { Simulation } from "src/types/coaching/simulation";


export interface MicroLearningContextProps {
  id?: string;
  article?: Article;
  assets?: Asset[];
  podcast?: Podcast;
  simulation?: Simulation;
  flashCards?: any;
  quiz?: any;

  showHistory?: boolean;
  expanded?: boolean;

  // eslint-disable-next-line no-unused-vars
  onBack?: () => void;

  // eslint-disable-next-line no-unused-vars
  onHistoryClick?: () => void;

  // eslint-disable-next-line no-unused-vars
  onExpand?: () => void;
  showDelete?: boolean;
  onDeleteClick?: () => void;

}

export const MicroLearningContext = React.createContext<MicroLearningContextProps>({
});